export const PROJECTS_VERSIONS_QUERY_PARAMS = [
	'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page',
];
